import { render, staticRenderFns } from "./DropdownForm.vue?vue&type=template&id=1cfe6db7&"
import script from "./DropdownForm.vue?vue&type=script&lang=js&"
export * from "./DropdownForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports